import {
  formatNormalNumber,
  formatPercentageValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, UserInteractionData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const interactionRatioByUser: KpiHandler = {
  type: 'KpiTile',
  handler: (data: UserInteractionData): KpiData => {
    const { interactionRatioByUser, interactionRatioByUserDelta } = data;

    const formattedValue = formatNormalNumber(interactionRatioByUser);
    const tag = {
      text: formatPercentageValue(Math.abs(interactionRatioByUserDelta)),
      isPositiveValue: interactionRatioByUserDelta >= 0,
    };

    return createKpiTileItem(
      'Interaction Ratio By Users',
      formattedValue,
      interactionRatioByUserDelta ? tag : []
    );
  },
};

export default interactionRatioByUser;
